import React from "react";

import { fmtBRL } from "./tokens";

// Métricas do topo por variante. `metrics` = { ativos, pipeline, risco, ganhos }.
// `funnel` também recebe `columns` (cada { stage, count }) para a barra do funil.

const SunlitMetrics = ({ metrics }) => {
  const cardStyle = {
    background: "#fff",
    borderRadius: 14,
    padding: "12px 16px",
    boxShadow: "0 1px 2px rgba(60,50,30,.06)",
  };
  const labelStyle = {
    fontSize: 10.5,
    fontWeight: 800,
    letterSpacing: ".07em",
    textTransform: "uppercase",
    color: "#A79E8C",
  };
  const valStyle = { fontSize: 22, fontWeight: 900, marginTop: 2 };
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4,1fr)",
        gap: 12,
      }}
    >
      <div style={cardStyle}>
        <div style={labelStyle}>Leads ativos</div>
        <div style={{ ...valStyle, color: "#33302B" }}>{metrics.ativos}</div>
      </div>
      <div style={cardStyle}>
        <div style={labelStyle}>Pipeline aberto</div>
        <div style={{ ...valStyle, color: "#2E90FA" }}>
          {fmtBRL(metrics.pipeline)}
        </div>
      </div>
      <div style={cardStyle}>
        <div style={labelStyle}>SLA em risco</div>
        <div style={{ ...valStyle, color: "#E5484D" }}>{metrics.risco}</div>
      </div>
      <div style={cardStyle}>
        <div style={labelStyle}>Ganhos no mês</div>
        <div style={{ ...valStyle, color: "#27AE60" }}>
          {fmtBRL(metrics.ganhos)}
        </div>
      </div>
    </div>
  );
};

const FunnelMetrics = ({ metrics, columns }) => {
  const boxStyle = {
    border: "1px solid #E9EDF2",
    borderRadius: 12,
    padding: "14px 16px",
  };
  const labelStyle = {
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: ".07em",
    textTransform: "uppercase",
    color: "#98A2B3",
  };
  return (
    <div style={{ display: "flex", gap: 16, alignItems: "stretch" }}>
      <div style={{ flex: 1, ...boxStyle }}>
        <div style={{ ...labelStyle, marginBottom: 9 }}>
          Distribuição do funil
        </div>
        <div
          style={{
            display: "flex",
            height: 34,
            borderRadius: 8,
            overflow: "hidden",
            gap: 2,
          }}
        >
          {columns.map((c) => (
            <div
              key={c.stage.id}
              style={{
                flexGrow: Math.max(c.count, 1),
                flexBasis: 0,
                minWidth: 44,
                background: c.stage.color || "#64748B",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: 13,
                fontWeight: 700,
              }}
            >
              {c.count}
            </div>
          ))}
        </div>
        <div style={{ display: "flex", marginTop: 6, gap: 2 }}>
          {columns.map((c) => (
            <div
              key={c.stage.id}
              style={{
                flexGrow: Math.max(c.count, 1),
                flexBasis: 0,
                minWidth: 44,
                fontSize: 10,
                fontWeight: 600,
                color: "#7A8496",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "center",
              }}
            >
              {c.stage.name}
            </div>
          ))}
        </div>
      </div>
      <div
        style={{
          width: 190,
          flex: "none",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          ...boxStyle,
        }}
      >
        <div style={labelStyle}>Pipeline aberto</div>
        <div
          style={{
            fontSize: 21,
            fontWeight: 800,
            color: "#151B26",
            marginTop: 1,
          }}
        >
          {fmtBRL(metrics.pipeline)}
        </div>
      </div>
      <div
        style={{
          width: 190,
          flex: "none",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          ...boxStyle,
        }}
      >
        <div style={labelStyle}>SLA em risco</div>
        <div
          style={{
            fontSize: 21,
            fontWeight: 800,
            color: "#E5484D",
            marginTop: 1,
          }}
        >
          {metrics.risco}{" "}
          <span style={{ fontSize: 12, fontWeight: 600, color: "#98A2B3" }}>
            leads
          </span>
        </div>
      </div>
    </div>
  );
};

const SoftMetrics = ({ metrics }) => {
  const chipStyle = {
    background: "rgba(255,255,255,.55)",
    border: "1px solid rgba(255,255,255,.75)",
    borderRadius: 12,
    padding: "8px 16px",
  };
  const labelStyle = {
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: ".08em",
    textTransform: "uppercase",
    color: "#8A7A9C",
  };
  const valStyle = { fontSize: 17, fontWeight: 800 };
  return (
    <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
      <div style={chipStyle}>
        <div style={labelStyle}>Leads ativos</div>
        <div style={{ ...valStyle, color: "#3D3350" }}>{metrics.ativos}</div>
      </div>
      <div style={chipStyle}>
        <div style={labelStyle}>Pipeline aberto</div>
        <div style={{ ...valStyle, color: "#3D3350" }}>
          {fmtBRL(metrics.pipeline)}
        </div>
      </div>
      <div style={chipStyle}>
        <div style={labelStyle}>SLA em risco</div>
        <div style={{ ...valStyle, color: "#C0392B" }}>{metrics.risco}</div>
      </div>
      <div style={chipStyle}>
        <div style={labelStyle}>Ganhos no mês</div>
        <div style={{ ...valStyle, color: "#1E7A46" }}>
          {fmtBRL(metrics.ganhos)}
        </div>
      </div>
    </div>
  );
};

const KanbanMetrics = ({ variant, metrics, columns }) => {
  if (variant === "sunlit") return <SunlitMetrics metrics={metrics} />;
  if (variant === "soft") return <SoftMetrics metrics={metrics} />;
  return <FunnelMetrics metrics={metrics} columns={columns} />;
};

export default KanbanMetrics;
